export enum EStorePhase {
    PRE_LOGIN = 'PreLogin',
    POST_LOGIN = 'PostLogin',
    POST_ORDER = 'PostOrder',
    OTHER = 'Other',
}

export enum ESectionsViewModel {
    DEFAULT = 'default',
    BAGEL_CODE = 'bagelcode',
    PIPA = 'pipa',
    Whispers = 'whispers',
    LLC = 'llc',
    MIGHTY_FU_CASINO = 'mighty-fu-casino',
    GHOST = 'ghost',
}

export enum StoreBodyBlock {
    dailyBonus = 'dailyBonus',
    playerLevel = 'playerLevel',
    banners = 'banners',
    progressBars = 'progressBars',
    specialOffers = 'specialOffers',
    rollingOffers = 'rollingOffers',
    bundles = 'bundles',
    richText = 'richText',
    faq = 'faq',
}

export enum ESupportType {
    PRE_LOGIN = 'preLogin',
    POST_LOGIN = 'postLogin',
}
